import React, {
  Component,
  Fragment,
  useEffect,
  useMemo,
  useState,
} from "react";

import users from "../../assets/images/icon_home/user.svg";
import * as API from "../../core/service/api.js";
import { } from "../../core/feature/store";
import * as api_info from "../../core/service/api_info";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Tabs from "../__template/BottomNavComponent";
import "react-lazy-load-image-component/src/effects/blur.css";
import { formatCurrency } from "../../config/global";
import User from "../../core/models/user";
import Config from "../../config/Config";
import { useDispatch } from "react-redux";
import { setToken } from "../../core/feature/token/tokenSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import { Listbox } from "@headlessui/react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import banner from "../../assets/images/icon_stock/banner.png";
import _ from "lodash";
import { setLoading } from "../../core/feature/config/configSlice";
import { toast } from "react-toastify";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";

const people = [
  { name: "Wade Cooper" },
  { name: "Arlene Mccoy" },
  { name: "Devon Webb" },
  { name: "Tom Cook" },
  { name: "Tanya Fox" },
  { name: "Hellen Schmidt" },
];

const InfoMobile = () => {
  const balance: Number = useAppSelector((state) => state.balance.balance);
  const user: User = useAppSelector((state) => state.user.user);
  const token: String = useAppSelector((state) => state.token.token);
  const dataTags = JSON.parse(String(localStorage.getItem("tags")));
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [pages, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [dataNews, setdataNews] = useState<any>([]);
  let [isOpen, setIsOpen] = useState(true);
  let [noData, setNoData] = useState(false);
  let [selectedItem, setSelectedItem] = useState<any>([]);
  const [tags, setTags] = useState<any>([]);
  const [selectedTags, setSelectedTags] = useState<any>([]);
  const [selectedAllTags, setSelectedAllTags] = useState<any>([]);
  const [isAll, setIsAll] = useState(true);
  // const [selected, setSelected] = useState(people[0]);
  const { t } = useTranslation();
  const env = Config.BaseUrlDev;
  const getBalance = useMemo(() => formatCurrency(balance), [balance]);
  useEffect(() => {
    if (user == undefined) {
      navigate("/login", { replace: true });
    } else {
      getAllTags();
    }
  }, []);

  function getAllTags() {
    setTags(dataTags);
  }

  function openModal(item: any) {
    // console.log(item._id);
    setSelectedItem(item);
    // setIsOpen(true);
    // navigate("/info-detail/" + item._id, { replace: true });
    navigate("/info-detail/" + item._id);
  }

  function getData() {
    dispatch(setLoading(true));
    setPage(0);

    var findTags = _.findIndex(selectedTags, function (o) {
      return o == "info";
    });

    if (findTags == 0) {
      var temp = _.concat(selectedTags, dataTags);
      api_info.getInfoNews(0, temp, size).then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
      });
    } else {
      api_info.getInfoNews(0, selectedTags, size).then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
      });
    }
  }

  const addMoreInfo = async () => {
    dispatch(setLoading(true));

    setPage(pages + 1);

    var findTags = _.findIndex(tags, function (o) {
      return o == "info";
    });

    if (findTags == 0) {
      var temp = _.concat(tags, dataTags);
      api_info
        .getInfoNews(pages + 1, temp, size)
        .then((res) => {
          dispatch(setLoading(false));
          setData(data.concat(res.data.content));
          console.log(res.data);
        })
        .catch((err) => {
          dispatch(setLoading(false));
        });
    } else {
      api_info
        .getInfoNews(pages + 1, selectedTags, size)
        .then((res) => {
          dispatch(setLoading(false));
          setData(data.concat(res.data.content));
          console.log(res.data);
        })
        .catch((err) => {
          dispatch(setLoading(false));
        });
    }
  };

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function getYtCode(str: String) {
    var regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = str.match(regExp);
    let x = "";
    if (match && match[2].length == 11) {
      x = match[2];
    } else {
      //error
    }
    return String(x)
      .replace("/", "")
      .replace("v=", "")
      .replace("?", "")
      .replace("#", "");
  }

  const selectTab = async (item: any) => {
    if (item != "all") {
      setIsAll(false);
      var evens2 = _.remove(selectedTags, function (n) {
        return n != "info";
      });
      if (evens2.includes(item)) {
        var evens = _.remove(evens2, function (n) {
          return n != item;
        });

        setSelectedTags(evens);
      } else {
        setSelectedTags([...evens2, item]);
      }
    } else {
      setSelectedTags(["info"]);
      setIsAll(true);
    }
  };

  const currentSizeInfo = useMemo(() => {
    const a = data.length;
    const b = a / (pages + 1);

    return b;
  }, [data]);

  useEffect(() => {
    setPage(0);
    if (selectedTags.length == 0) {
      setSelectedTags(["info"]);
      setIsAll(true);
    }
    getData();
  }, [selectedTags]);

  return (
    <>
      <div className="relative min-h-screen h-full  bg-psp-primary pb-10">
        <div className="sticky top-0 z-50 bg-psp-primary p-3 w-full">
          <h1 className="font-montserrat m-0 font-bold text-base text-black">
            {`${t("INFO.title")}`}
          </h1>

          <div className="flex flex-row sticky mb-0 mt-2 top-20 z-50 overflow-x-scroll overflow-y-hidden">
            <button
              onClick={() => selectTab("all")}
              className={
                isAll
                  ? `bg-psp-btn-primary p-2 rounded-md mx-1 ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`
                  : "bg-white p-2 rounded-md mx-1 text-gray-600"
              }
              style={{
                backgroundColor: isAll ? customApp?.app_accent_color : "#fff",
              }}
            >
              Semua
            </button>
            {tags.map((item: any) => {
              return (
                <button
                  onClick={() => selectTab(item)}
                  style={{
                    backgroundColor: selectedTags.includes(item)
                      ? customApp?.app_accent_color
                      : "#fff",
                    color: !selectedTags.includes(item)
                      ? "gray"
                      : isDarkColor(customApp.app_accent_color)?'white':'black',
                  }}
                  className={
                    selectedTags.includes(item)
                      ? " p-2 rounded-md mx-1 h-10"
                      : " p-2 rounded-md mx-1 h-10 break-words"
                  }
                >
                  {" "}
                  {item}{" "}
                </button>
              );
            })}
          </div>
        </div>
        <div className="min-h-screen h-full mb-6 px-4 pb-4 bg-psp-primary">
          <section className="mt-2">
            <div className="top-to-bottom z-0">
              <div className="flex flex-col gap-4">
                {data.length < 1 ? (
                  <div className="flex justify-center">
                    <span className="font-normal text-xs text-center">
                      {t("OTHER.dataNotFound")}
                    </span>
                  </div>
                ) : (
                  <div className="flex flex-col gap-3 ">
                    {data.map((item: any) =>
                      item.isOpen == true ? (
                        <div
                          onClick={() => {
                            openModal(item);
                          }}
                          className="flex flex-row gap-0.5 rounded-xl bg-white"
                        >
                          <div className="w-1/3 overflow-hidden">
                            {(item.videoUrl ||
                              item.image ||
                              item.imageOpt.length > 0) &&
                              item.imageOpt.length < 1 &&
                              item.image && (
                                <img
                                  className="h-28 w-32 object-contain overflow-hidden rounded-l-xl flex"
                                  src={getImgContent(item.image)}
                                />
                              )}

                            {item.imageOpt.length > 0 && item.image && (
                              <img
                                className="h-28 w-32 object-cover overflow-hidden rounded-l-xl flex"
                                src={getImgContent(item.image)}
                                alt=""
                              />
                            )}
                            {item.imageOpt.length > 0 && !item.image && (
                              <img
                                className="h-28 w-32 object-cover overflow-hidden rounded-l-xl flex"
                                src={getImgContent(item.imageOpt[0])}
                                alt=""
                              />
                            )}
                            {item.imageOpt.length == 0 &&
                              !item.image &&
                              item.videoUrl && (
                                <img
                                  className="h-28 w-32 object-cover overflow-hidden rounded-l-xl flex"
                                  src={`https://img.youtube.com/vi/${getYtCode(
                                    item.videoUrl
                                  )}/sddefault.jpg`}
                                  alt=""
                                />
                              )}

                            {item.imageOpt.length == 0 &&
                              item.image == "" &&
                              item.videoUrl == "" && (
                                <img
                                  className="h-28 w-32 object-cover overflow-hidden rounded-l-xl flex"
                                  src={banner}
                                />
                              )}
                          </div>
                          <div className="flex flex-col w-2/3  gap-1 px-1 py-2">
                            <span className="text-xs">
                              {moment(item.updateTime).format("LL")}
                            </span>

                            <h1 className="m-0 text-xs font-bold font-montserrat">
                              {item.title}
                            </h1>

                            <h1 className="text-[9px] text-psp-gray font-normal font-montserrat">
                              {item.subtitle.length > 100
                                ? item.subtitle.substring(0, 99) + "..."
                                : item.subtitle}
                            </h1>
                          </div>
                        </div>
                      ) : (
                        // <div
                        //   className="flex flex-row bg-white rounded-xl gap-1.5 items-center overflow-hidden"
                        //   onClick={() => {
                        //     openModal(item);
                        //   }}
                        // >
                        //   {(item.videoUrl ||
                        //     item.image ||
                        //     item.imageOpt.length > 0) &&
                        //     item.imageOpt.length < 1 &&
                        //     item.image && (
                        //       <div className="h-24 w-32">
                        //         <LazyLoadImage
                        //           className="h-24 w-32 object-cover "
                        //           effect="blur"
                        //           src={getImgContent(item.image)}
                        //         />
                        //       </div>
                        //     )}

                        //   {item.imageOpt.length > 0 && item.image && (
                        //     <div className="h-24 w-32">
                        //       <LazyLoadImage
                        //         className="h-24 w-32 object-cover "
                        //         effect="blur"
                        //         src={getImgContent(item.image)}
                        //         alt=""
                        //       />
                        //     </div>
                        //   )}
                        //   {item.imageOpt.length > 0 && !item.image && (
                        //     <div className="h-24 w-32">
                        //       <LazyLoadImage
                        //         className="h-24 w-32 object-cover "
                        //         effect="blur"
                        //         src={getImgContent(item.imageOpt[0])}
                        //         alt=""
                        //       />
                        //     </div>
                        //   )}
                        //   {item.imageOpt.length == 0 &&
                        //     !item.image &&
                        //     item.videoUrl && (
                        //       <LazyLoadImage
                        //         className="h-24 w-32 object-cover "
                        //         effect="blur"
                        //         src={`https://img.youtube.com/vi/${getYtCode(
                        //           item.videoUrl
                        //         )}/sddefault.jpg`}
                        //         alt=""
                        //       />
                        //     )}

                        //   {item.imageOpt.length == 0 &&
                        //     item.image == "" &&
                        //     item.videoUrl == "" && (
                        //       <LazyLoadImage
                        //         className="h-24 w-32 object-cover "
                        //         effect="blur"
                        //         src={banner}
                        //       />
                        //     )}
                        //   <div className="flex flex-col gap-1  px-2">
                        //     <span className="m-0 text-psp-gray text-[9px] font-normal font-montserrat">
                        //       {moment(item.createTime).format("LL")}
                        //     </span>

                        //     <h1 className="m-0 text-xs font-bold font-montserrat">
                        //       {item.title}
                        //     </h1>

                        //     <h1 className=" text-[9px] text-psp-gray font-normal font-montserrat">
                        //       {item.subtitle.length > 100
                        //         ? item.subtitle.substring(0, 99) + "..."
                        //         : item.subtitle}
                        //     </h1>
                        //   </div>
                        // </div>
                        ""
                      )
                    )}
                  </div>
                )}
              </div>
            </div>
          </section>
          {currentSizeInfo < 10 ? (
            ""
          ) : (
            <div className="flex w-full">
              <button
                onClick={addMoreInfo}
                className="w-full transparent px-2 py-2.5 rounded-lg text-psp-hover underline text-center items-center font-bold text-xs active:text-psp-active "
              >
                {t("OTHER.showMore")}
              </button>
            </div>
          )}
        </div>
        <Tabs tab={`${t("NAVBAR.info")}`}></Tabs>
      </div>
    </>
  );
};
export default InfoMobile;
